// extracted by css-extract-rspack-plugin
export default {"progress":"progress-mUL88n","bar":"bar-Alh_0Q"};